<template>
  <div>
    <v-dialog v-if="dialog" v-model="dialog" persistent width="100" no-click-animation>
      <v-card color="primary"
              dark>
        <v-card-text>
          Loading
          <v-progress-linear indeterminate
                             color="white"
                             class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container v-else style="height: 50vh;">
      <v-layout align-center justify-center row fill-height>
        <v-card color="primary"
                dark>
          <v-card-text>
            Loading
            <v-progress-linear indeterminate
                               color="white"
                               class="mb-0" />
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  export default {
    props: ['dialog'],
    data() {
      return {
        dlg: false
      }
    }
  }
</script>
